import React, { useMemo } from 'react';
import BaseSelectBox from 'components/atoms/base-select-box';
import {
  clinicSalesForceDataSource,
  type IClinicSalesForceItem,
} from 'infrastructure/data-sources/clinic-sales-force';

import type {
  IBaseSelectBoxOption,
  IBaseSelectBoxProps,
} from 'components/atoms/base-select-box/types';

type Options = IBaseSelectBoxOption<
  IClinicSalesForceItem['id'],
  IClinicSalesForceItem
>[];

interface IClinicSalesForceSelectBoxProps
  extends Omit<IBaseSelectBoxProps, 'options'> {}

const ClinicSalesForceSelectBox: React.FC<IClinicSalesForceSelectBoxProps> = (
  props,
) => {
  const dataSource = useMemo(() => clinicSalesForceDataSource(), []);

  const options: Options = useMemo(
    () =>
      dataSource.map((el) => ({
        value: el.id,
        label: el.name,
        record: el,
      })),
    [dataSource],
  );

  return <BaseSelectBox options={options} {...props} />;
};

export default ClinicSalesForceSelectBox;
